import { Routes } from '@angular/router';
import { FullLayoutComponent } from '@shared/full-layout/full-layout.component';

export const appRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@screens/login/login.component')
      .then(m => m.LoginComponent)
  },
  {
    path: 'login-clerk',
    loadComponent: () => import('@screens/login-clerk/login-clerk.component')
      .then(m => m.LoginClerkScreenComponent),
    data: { showBottomNav: false }
  },
  {
    path: '',
    component: FullLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('@screens/home/home.component')
          .then(m => m.HomeScreenComponent)
      },
      {
        path: 'direction',
        loadComponent: () => import('@screens/direction/direction.component')
          .then(m => m.DirectionScreenComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'chat',
        loadComponent: () => import('@screens/chat-screen/chat-screen.component')
          .then(m => m.ChatScreen),
        data: { showBottomNav: false }
      },
      {
        path: 'camera',
        loadComponent: () => import('@screens/camera/camera.component')
          .then(m => m.CameraScreenComponent),
        data: { showBottomNav: false, showHeader: false }
      },
      {
        path: 'wizard',
        loadComponent: () => import('@screens/form-wizard/form-wizard.component')
          .then(m => m.FormWizardComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'wizard-new',
        loadComponent: () => import('@screens/form-wizard-new/form-wizard-new.component')
          .then(m => m.FormWizardNewComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'confirm-update-profile',
        loadComponent: () => import('@screens/confirm-update-profile/confirm-update-profile.component')
          .then(m => m.confirmUpdateProfileScreenComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'confirm-submition',
        loadComponent: () => import('@screens/confirm-submition/confirm-submition.component')
          .then(m => m.confirmSubmitionScreenComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'create-account',
        loadComponent: () => import('@screens/create-account/create-account.component')
          .then(m => m.CreateAccountScreenComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'files',
        loadComponent: () => import('@screens/files/files.component')
          .then(m => m.FilesComponent)
      },
      {
        path: 'final',
        loadComponent: () => import('@screens/final-page/final-page.component')
          .then(m => m.FinalPageComponent)
      },
      {
        path: 'share/select',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'settings',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'personal-information',
        loadComponent: () => import('@screens/personal-info/personal-info.component')
          .then(m => m.PersonalInfoScreenComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'insurance-information',
        loadComponent: () => import('@screens/insurance-info/insurance-info.component')
          .then(m => m.InsuranceInfoScreenComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'my-doctors',
        loadComponent: () => import('@screens/my-doctor/my-doctor.component')
          .then(m => m.MyDoctorScreenComponent),
        data: { showBottomNav: false }
      },
      {
        path: 'my-prescriptions',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'imaging-test-results',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'surgeries-procedures',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'diagnoses-conditions',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'child1',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'child2',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'caregiver-responsibilities',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'mother',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'father-in-law',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'uncle',
        loadComponent: () => import('@screens/placeholder/placeholder.component')
          .then(m => m.PlaceholderScreenComponent),
        data: { title: 'Coming Soon', showBottomNav: false }
      },
      {
        path: 'my-submissions',
        loadComponent: () => import('@screens/my-submission/my-submission.component')
          .then(m => m.MySubmissionScreenComponent),
        data: { showBottomNav: false }
      },
    ]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
